<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>FEMINIST NIGHTMARES</strong></h1>
<p class="subtitle"><strong>WOMEN AT ODDS</strong></p>
<p class="subtitle">Feminism and the Problem of Sisterhood</p>
<p class="author"><span class="small">EDITED BY</span><br/>SUSAN OSTROV WEISSER<br/>AND<br/>JENNIFER FLEISCHNER</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6e706f56